import React, { useEffect, useState } from "react";
import "./MembershipCard.css";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader";
import DescriptionText from "../../../../CommonComponents/DescriptionText";
import MetallicCard from "./MetallicCard/MetallicCard";
import { Radio, Select } from "antd";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../store/adminData/adminData";
import { toast } from "react-toastify";
import { fbUploadMembershipCard } from "../../../../services/firebaseService/endPoints/user";
import { postUpdateCDNUtil } from "../../../../helperFunctions/util";
import logger from "../../../../utils/logger";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../../../services/firebaseService/connection";
import ImageUploadButton from "../../website/ImageUploaderButton";
const MembershipCard = () => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedTextColor, setSelectedTextColor] = useState("Black");

  const [imageFiles, setImageFiles] = useState({
    membershipCard: null,
    membershipCardBackground: null,
  });

  const [loading, setLoading] = useState(false);

  const handleImageChange = (file, fieldName) => {
    if (fieldName === "membershipCardBackground") {
      setImageFiles({
        ...imageFiles,
        membershipCardBackground: file,
      });
    } else if (fieldName === "membershipCard") {
      setImageFiles({
        ...imageFiles,
        membershipCard: file,
      });
    }
  };

  useEffect(() => {
    if (groupData?.id) {
      setImageFiles({
        membershipCardBackground: groupData?.membershipCardBackground || null,
        membershipCard: groupData?.membershipCard || null,
      });
      setSelectedTextColor(
        groupData?.memberCardTextColor === "#000000" ? "Black" : "White",
      );
      setSelectedTemplate(groupData?.membershipCardTemplate || null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupData?.id]);

  const uploadImage = async (file, fieldName) => {
    try {
      const downloadUrl = await fbUploadMembershipCard(
        file,
        groupData?.id,
        fieldName,
      );
      return downloadUrl;
    } catch (error) {
      logger.error("Failed to upload image", error);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      let membershipCardUrl = null;
      let membershipCardBackgroundUrl = null;

      if (typeof imageFiles?.membershipCard === "object") {
        membershipCardUrl = await uploadImage(
          imageFiles?.membershipCard,
          "membershipCard",
        );
      } else if (
        typeof imageFiles?.membershipCard === "string" &&
        imageFiles?.membershipCard?.length > 0
      ) {
        membershipCardUrl = imageFiles?.membershipCard;
      }

      if (typeof imageFiles?.membershipCardBackground === "object") {
        membershipCardBackgroundUrl = await uploadImage(
          imageFiles?.membershipCardBackground,
          "membershipCardBackground",
        );
      } else if (
        typeof imageFiles?.membershipCardBackground === "string" &&
        imageFiles?.membershipCardBackground?.length > 0
      ) {
        membershipCardBackgroundUrl = imageFiles?.membershipCardBackground;
      }

      const payload = {
        membershipCardTemplate: selectedTemplate,
        membershipCardBackground: membershipCardBackgroundUrl,
        membershipCard: membershipCardUrl,
        memberCardTextColor:
          selectedTextColor === "Black" ? "#000000" : "#FFFFFF",
      };

      const docRef = doc(db, "group", groupData?.id);
      setDoc(docRef, payload, { merge: true });

      postUpdateCDNUtil(groupData?.id);

      toast.success("Membership card updated successfully");
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="membership-card-container">
      <ScreenHeader title="Member Card" />
      <div className="membership-card-description">
        <DescriptionText>
          Chant offers a digital membership card so your group no longer needs
          to spend money printing physical cards. Alert your partners to accept
          the card for any discounts the group has negotiated.
        </DescriptionText>
      </div>
      <div className="membership-card-content">
        <div className="membership-card-content-container">
          <div className="membership-cards">
            <h5 style={{ fontSize: "18px", fontWeight: "bold" }}>
              Member card design
            </h5>
            <div className="membership-card-content-header">
              <p>
                To customize the front of your member card, select one of the
                default styles or upload your own jpg (16x9). Cards are dynamic
                and flip to show member details. Non-members will see static
                card with ‘for Members only’.
              </p>
            </div>

            <div className="membership-card-templates">
              <div className="membership-card-template">
                <Radio
                  disabled={loading}
                  className="pb-2"
                  checked={selectedTemplate === "singleTone"}
                  onChange={() => setSelectedTemplate("singleTone")}
                >
                  Single Tone
                </Radio>
                <MetallicCard
                  onClick={() => setSelectedTemplate("singleTone")}
                />
              </div>
              <div className="membership-card-template">
                <Radio
                  disabled={loading}
                  className="pb-2"
                  checked={selectedTemplate === "dualTone"}
                  onChange={() => setSelectedTemplate("dualTone")}
                >
                  Dual Tone
                </Radio>
                <MetallicCard
                  type="dualTone"
                  onClick={() => setSelectedTemplate("dualTone")}
                />
              </div>

              <div className="membership-card-template">
                <Radio
                  disabled={loading}
                  className="pb-2"
                  checked={selectedTemplate === "custom"}
                  onChange={() => setSelectedTemplate("custom")}
                >
                  Upload Image (front of card)
                </Radio>

                <ImageUploadButton
                  images={
                    imageFiles.membershipCard ? [imageFiles.membershipCard] : []
                  }
                  onSave={(images) =>
                    handleImageChange(images[0], "membershipCard")
                  }
                  aspectRatio={16 / 9}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: "16px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ChantButton
            disabled={loading}
            loading={loading}
            onClick={handleSubmit}
          >
            Submit
          </ChantButton>
        </div>
      </div>
    </div>
  );
};

export default MembershipCard;
